// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"SeminarianSelection_wrapperSelect__t--v5","select":"SeminarianSelection_select__xB9bU"};